import { Component } from 'react'
import * as Sentry from '@sentry/browser'

// Sentry.init({
//  dsn: "https://0ad6a1b0f01d4457b500db372744166e@sentry.io/1406119"
// });
// should have been called before using it here
// ideally before even rendering your react app

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key])
      })
      Sentry.captureException(error)
    })
  }

  render() {
    if (this.state.error) {
      // render fallback UI
      return null // <a onClick={() => Sentry.showReportDialog()}>Report feedback</a>
    }
    // when there's not an error, render children untouched
    return this.props.children
  }
}

export default ErrorBoundary
